import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/Subtopic1/Limpieza_Contenedores_V2.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";

export class ContainerCleaning extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		this.nameObjectSelect = {
			Trapo: "Trapo",
			Cepillo: "Cepillo",
			Condimentero: "Condimentero",
			Hotdog_3: "Condimentero",
			Hotdog_2: "Condimentero",
			Hotdog_1: "Condimentero",
			Catsup_2: "Condimentero",
			Catsup_1: "Condimentero",
			Servilletas: "Condimentero",
			Mostaza_2: "Condimentero",
			Mostaza_1: "Condimentero",
			Mayonesa_2: "Condimentero",
			Mayonesa_6: "Condimentero",
			Condimentos: "Condimentero",
			Contenedor_verduras: "Contenedor_verduras",
			Contenedor: "Contenedor_verduras",
			Jalapenos: "Contenedor_verduras",
			Cebolla: "Contenedor_verduras",
			Jitomate: "Contenedor_verduras",
			Pinzas: "Pinzas",
			Salchichas: "Salchichas",
		};
		this.nameNotMaterial = {
			Condimentero: "Condimentero",
			Contenedor_verduras: "Contenedor_verduras",
		};
		this.selectCurrentObject = null;
		this.animationOnlyObject = null;
		this.observerListtneners();
		// this.helpers();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			// gltf.scene.visible = false;
			this.add(gltf.scene);

			this.Trapo = gltf.scene.getObjectByName("Trapo", true);
			this.Cepillo = gltf.scene.getObjectByName("Cepillo", true);
			this.Condimentero = gltf.scene.getObjectByName("Condimentero", true);
			this.Contenedor_verduras = gltf.scene.getObjectByName("Contenedor_verduras", true);
			this.Pinzas = gltf.scene.getObjectByName("Pinzas", true);
			this.Salchichas = gltf.scene.getObjectByName("Salchichas", true);
		});
	}

	observerListtneners() {

	}

	onSelectAnimation(objectName = "") {
		const nameSelect = this.nameObjectSelect[objectName];
		if (nameSelect === undefined) {
			return;
		}

		if (this.selectCurrentObject) {
			const isEqualObject = nameSelect === this.selectCurrentObject.name;
			if (isEqualObject) {
				return;
			}
		}

		if (this.nameNotMaterial[nameSelect] !== undefined) {
			const nameObjectChildren = this.nameNotMaterial[nameSelect];
			this.onAnimationSelectChildren(this[nameObjectChildren]);
			return;
		}

		this.onAnimationSelect(this[nameSelect]);
	}

	clearAll() {
		this.elimintaAnimations()
		this.restoreAnimations()
	}

	elimintaAnimations() {
		if (this.animation) {
			this.animation.kill();
		}
		if (this.animationChildren) {
			this.animationChildren.kill();
		}
	}

	restoreAnimations() {
		// Restaurar la intensidad de emisión de un objecto
		if (this.animationOnlyObject) {
			this.animationOnlyObject.material.emissiveIntensity = 1;
			this.animationOnlyObject.material.emissive.set("#000000");
		}

		// Restaurar la intensidad de emisión en los hijos anteriores si existen
		if (this.selectedChildren) {
			for (let i = 0; i < this.selectedChildren.length; i++) {
				this.selectedChildren[i].emissiveIntensity = 1;
				this.selectedChildren[i].emissive.set("#000000");
			}
		}
	}

	onAnimationSelectChildren(object) {
		this.elimintaAnimations();

		this.selectCurrentObject = object;

		this.restoreAnimations();

		// Obtener los hijos específicos que deseas iluminar
		this.selectedChildren = object.children.map((child) => {
			return child.material;
		});

		// Aplicar la nueva animación a los hijos seleccionados
		this.animationChildren = gsap.to(this.selectedChildren, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	onAnimationSelect(object) {
		this.elimintaAnimations();

		this.selectCurrentObject = object;

		this.restoreAnimations();

		this.animationOnlyObject = object;

		object.material.emissive.set("#404040");


		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	onNewMaterial(object) {
		const newMaterial = object.material.clone();
		object.material = newMaterial;
		object.material.emissive.set("#404040");
	}

	onAnimate(object, previousObject) {
		if (this.animation) {
			this.animation.kill();
		}

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}


	onVisibleAll() {
		this.Trapo.visible = true
		this.Cepillo.visible = true
		this.Condimentero.visible = true
		this.Contenedor_verduras.visible = true
		this.Pinzas.visible = true
		this.Salchichas.visible = true
	}

	onInVisibleAll() {
		this.Trapo.visible = false
		this.Cepillo.visible = false
		this.Condimentero.visible = false
		this.Contenedor_verduras.visible = false
		this.Pinzas.visible = false
		this.Salchichas.visible = false
	}

	onMoveObjectTarget(target = { x: 0, y: 0, z: 0 }, object, duration = 1, callback = () => { }) {
		setTimeout(() => {
			gsap.to(object.position, {
				x: target.x,
				y: target.y,
				z: target.z,
				duration: duration,
				onComplete: callback,
			})
		}, 1000);
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Limpieza");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	helpersChild() {
		this.helperMethod("Trapo", this.Trapo);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -200, 200).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -200, 200).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -200, 200).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
